<template>
  <span>
    <span class="vue-delete-button-with-confirm-wrap">
       <b-button
       v-if="!deleteRequested"
       class="delete"
       v-on:click="onDeleteClick()">{{buttonText}}</b-button>
       <b-button
       v-if="deleteRequested"
       class="confirm-cancel"
       v-on:click="onCancelDeletelick()">Cancel delete</b-button>
       <b-button
       v-if="deleteRequested"
       class="confirm"
       v-on:click="onConfirmClick()">{{confirmText}}</b-button>
    </span>
  </span>
</template>

<script>
export default {
  name: 'DeleteButtonWithConfirm',
  props: {
  buttonText: String,
  confirmText: String,
  deleteClicked: Function,
  cancelClicked: Function,
  deleteConfirmClicked: Function
  },
  data() {
    return {
      deleteRequested: false
    }
  },
  methods: {
      onDeleteClick() {
       this.deleteRequested = true;
       this.deleteClicked();
      },
      onCancelDeletelick() {
        this.deleteRequested = false
        this.cancelClicked();
      },
      onConfirmClick() {
        this.deleteConfirmClicked();
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/partials/_variables.scss";

.vue-delete-button-with-confirm-wrap{
  button {
    border: none;
    border-radius: 20px;
    font-size: 13px;

    &.delete{
      margin-right: 10px;
      color: #fff;
      background-color: $red;
    }

    &.confirm{
      margin-right: 10px;
      color: #fff;
      background-color: $red;
    }

    &.confirm-cancel{
      margin-right: 10px;
      color: #fff;
      background-color: #000;
    }
  }
}
</style>
